export default class Palette {
    static KOMUNE_YELLOW = "#febe10";
    static MAIN_THEME = "#004EEB"; // Diubah jadi biru

    static THEME_YELLOW = "#febe10";
    static THEME_PURPLE = "#7f8fea";
    static THEME_GREEN = "#43936C";
    static THEME_RED = "#004EEB"; // Ini sudah biru
    
    // Untuk warna biru konsisten
    static BLUE_THEME = "#004EEB";
    static BLUE_LIGHT = "rgba(0, 78, 235, 0.1)";
    static BLUE_BORDER = "rgba(0, 78, 235, 0.2)";
    
    // Background & text
    static BACKGROUND_WHITE = "#FFFFFF";
    static BACKGROUND_LIGHT = "#FAFAFA";
    static TEXT_PRIMARY = "#333333";
    static TEXT_SECONDARY = "#666666";
    static TEXT_DISABLED = "#999999";
    
    static BACKGROUND_BLACK = "#121212";
    static BACKGROUND_DARK_GRAY = "#FFFFFF";
    static INACTIVE_GRAY = "#c2c2c2";
    static LIGHT_GRAY = "#f0f0f0";
    static WHITE_GRAY = "#757575";
    static WHITE = '#FFF';
    
    // Untuk tabel dan borders
    static BORDER_COLOR = "#f0f0f0";
    static TABLE_HEADER_BG = "#fafafa";
}